import { render, staticRenderFns } from "./SuspendedBusiness.vue?vue&type=template&id=488fd69d&"
import script from "./SuspendedBusiness.vue?vue&type=script&lang=js&"
export * from "./SuspendedBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports